// @ts-nocheck
import { CLEAR_PAGINATION, SET_PAGINATION } from '../types';

export const setPagination = (paginationKey, paginationProps) => ({
    type: SET_PAGINATION,
    payload: { paginationKey, paginationProps },
});

export const clearPagination = payload => ({
    type: CLEAR_PAGINATION,
    payload,
});
